define(["dojo-proxy-loader?name=dojo/_base/declare!/home/jenkins/agent/workspace/mailchimp-cd/MC-Mono-Build/node_modules/@mc/webpack-plugin-legacy-dojo/src/modules/noop-module", "mojo/page/request", "mojo/page/shouldTrack"], function (declare, request, shouldTrack) {
  return declare([], {
    constructor: function (params) {
      if (params.clientDntGating && !shouldTrack()) {
        return;
      }
      document.addEventListener("click", function (e) {
        // Get closest anchor, as sometimes this event target will be
        // an element inside an anchor, like an img.
        var anchor = e.target.closest("a");
        if (anchor === null) {
          return;
        }
        request.get(params.endpoint + "&url=" + encodeURIComponent(anchor.href));
      }, false);
    }
  });
});